module.exports = __webpack_public_path__ + "img/case1.67dcd4b0.jpg";